import FundingReport from 'models/FundingReportModel';

import { generateReducer } from 'reducers/utils/HttpReducerHelper';

import { fundingReportsList } from './types';

export * from './actions';

const fundingReportsListReducer = generateReducer('all', FundingReport.deserialize);

const fundingReportsListReducerObject = {
  [fundingReportsList.request]: fundingReportsListReducer.request,
  [fundingReportsList.success]: fundingReportsListReducer.success,
  [fundingReportsList.failure]: fundingReportsListReducer.failure,
};

export default fundingReportsListReducerObject;
